import ArticleMasterService from "../src/services/articleMasterService";
import CommonService from "../src/services/commonService";
import NProgress from "nprogress";
export const ArticleMasterMixin = {
	data() {
		return {
			// checked: "all",
			// outlets: [],
			// outletsSelected: [],
			// value: ""
		};
	},
	computed: {
		// selectedOutletId: {
		// 	get: function() {
		// 		return this.checked == "all" ? this.checked : this.outletsSelected;
		// 	},
		// 	set: function(newValue) {
		// 		this.checked = "all";
		// 		this.outletsSelected = [];
		// 	}
		// }
	},
	watch: {
		// checked: function(val) {
		// 	if (val == "all") {
		// 		this.outletsSelected = [];
		// 	}
		// }
	},
	created() {
		this.getAllOutlets({ get_all: true });
	},
	methods: {
		doesSubcategoryExist(subcategory) {
			return new Promise(resolve => {
				return ArticleMasterService.doesSubcategoryExist({
					subcategoryId: subcategory
				})
					.then(response => {
						if (response.status === 200) return resolve(true);
					})
					.catch(err => {
						console.log(err.response.status);
						NProgress.done();
						return resolve(false);
					});
			});
		},
		doesDepartmentExist(department) {
			return new Promise(resolve => {
				return ArticleMasterService.doesDepartmentExist({
					departmentId: department
				})
					.then(response => {
						if (response.status === 200) return resolve(true);
					})
					.catch(err => {
						console.log(err.response.status);
						NProgress.done();
						return resolve(false);
					});
			});
		},
		doesCategoryExist(category) {
			return new Promise(resolve => {
				return ArticleMasterService.doesCategoryExist({
					categoryId: category
				})
					.then(response => {
						if (response.status === 200) return resolve(true);
					})
					.catch(err => {
						console.log(err.response.status);
						NProgress.done();
						return resolve(false);
					});
			});
		},
		getAllOutlets(args) {
			CommonService.getOutlets(args)
				.then(response => {
					if (response.status == 200) {
						this.outlets = JSON.parse(response.data);
						// this.outlets = outlets.reduce((acc, v) => {
						// 	acc[v.name] = v.id;
						// 	return acc;
						// }, {});
					}
				})
				.catch(error => {
					console.log("error", error);
				});
		},
		getAllCategories({
			fields = ["id", "name"],
			departmentId,
			get_all = true
		} = {}) {
			return ArticleMasterService.getCategories({
				fields: fields,
				departmentId: departmentId,
				get_all: get_all
			}).then(response => {
				const categories = JSON.parse(response.data);
				return !categories.length
					? []
					: categories.map(category => ({
							id: category.id,
							name: category.name
					  }));
			});
		},
		getAllSubcategories({
			fields = ["id", "name"],
			categoryId,
			get_all = true
		} = {}) {
			return ArticleMasterService.getSubcategories({
				fields: fields,
				categoryId: categoryId,
				get_all: get_all
			}).then(response => {
				// this.articleMaster[index].addNewSubcategory = false; // related to disable of category dropodown
				const subcategories = JSON.parse(response.data);
				return !subcategories.length
					? []
					: subcategories.map(subcategory => ({
							id: subcategory.id,
							name: subcategory.name
					  }));
			});
		}
	}
};
